import { Button, MyIcon } from 'ccs-ui-components';
import { ChangeEvent, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import classes from './FileUploadButton.module.scss';

interface IFileUploadButtonProps {
  viewMode: boolean,
  onFileUploadSuccess: (fileData: string) => void
}
const FileUploadButton = ({ viewMode, onFileUploadSuccess }: IFileUploadButtonProps) => {
  let fileReader: FileReader;
  const ref = useRef<HTMLInputElement>(null);
  const { t: translate } = useTranslation();
  const handleFileRead = () => {
    onFileUploadSuccess(fileReader.result?.toString() || '');
  };
  const handleFileChange = (event: ChangeEvent<HTMLInputElement>) => {
    const fileObj = event.target.files && event.target.files[0];
    if (!fileObj) {
      return;
    }

    if (event?.target?.files !== null) {
      fileReader = new FileReader();
      fileReader.onloadend = handleFileRead;
      fileReader.readAsText(event.target.files[0]);
    }
  };
  const handleClick = () => {
    ref?.current?.click();
  };

  return (
    <div className={classes.container}>
      <div className={classes['input-label']}>
        <Button onClick={handleClick} variant="secondary" disabled={viewMode} data-testid="btn-fileUpload">
          <div className={classes['button-item']}>
            {translate('file_upload_button.txt_upload_file')} <div className={classes['icon-item']}><MyIcon name="uploadIcon" /></div>
          </div>
        </Button>
        <input
          className={classes['input-file']}
          data-testid="upload-input"
          disabled={viewMode}
          type="file"
          name="fileUpload"
          accept=".cbl"
          ref={ref}
          onChange={handleFileChange}
        />
      </div>
    </div>
  );
};

export default FileUploadButton;
